import { render, staticRenderFns } from "./menu-layoutV2.vue?vue&type=template&id=1da8c88e&scoped=true"
import script from "./menu-layoutV2.vue?vue&type=script&lang=js"
export * from "./menu-layoutV2.vue?vue&type=script&lang=js"
import style0 from "./menu-layoutV2.vue?vue&type=style&index=0&id=1da8c88e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da8c88e",
  null
  
)

export default component.exports